import { defineRoutes } from '@lognai/plugin-sdk';

export const pluginId = 'analytics';
const dashboardList = () =>
  import('./platform/DashboardListPage').then((module) => ({ default: module.DashboardListPage }));
const datasets = () =>
  import('./platform/DatasetsPage').then((module) => ({ default: module.DatasetsPage }));
const dashboard = () =>
  import('./platform/AnalyticsDashboardPage').then((module) => ({
    default: module.AnalyticsDashboardPage,
  }));
const home = () =>
  import('./platform/AnalyticsHomePage').then((module) => ({ default: module.AnalyticsHomePage }));
const redirect =
  (
    name:
      | 'AnalyticsHomeRedirect'
      | 'DashboardListRedirect'
      | 'RevenueFulfillmentRedirect'
      | 'InventoryWarehouseRedirect'
      | 'LogisticsDeliveryRedirect'
  ) =>
  () =>
    import('./platform/LegacyAnalyticsRedirect').then((module) => ({ default: module[name] }));

export const routes = defineRoutes(pluginId, '/analytics', [
  {
    path: '/datasets',
    component: datasets,
    name: 'Datasets',
    permissions: ['analytics:datasets:read'],
    nav: { icon: { name: 'Database', size: 20 }, showInNav: true, order: 3 },
  },
  {
    path: '',
    component: home,
    name: 'My dashboard',
    description: 'Dashboard-first business analytics workspace',
    permissions: ['analytics:dashboard:read'],
    nav: { icon: { name: 'BarChart3', size: 20 }, showInNav: true, order: 0 },
  },
  {
    path: '/dashboards',
    component: dashboardList,
    name: 'Dashboards',
    permissions: ['analytics:dashboard:read'],
    nav: { icon: { name: 'LayoutDashboard', size: 20 }, showInNav: true, order: 1 },
  },
  {
    path: '/dashboards/new',
    component: () =>
      import('./platform/DashboardCreatePage').then((module) => ({
        default: module.DashboardCreatePage,
      })),
    name: 'Create dashboard',
    permissions: ['analytics:dashboards:write'],
    nav: { showInNav: false },
  },
  {
    path: '/dashboards/:id',
    component: dashboard,
    name: 'Analytics dashboard',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/library',
    component: () =>
      import('./platform/VisualLibraryPage').then((module) => ({
        default: module.VisualLibraryPage,
      })),
    name: 'Chart library',
    permissions: ['analytics:dashboard:read'],
    nav: { icon: { name: 'Library', size: 20 }, showInNav: true, order: 2 },
  },
  {
    path: '/themes',
    component: () =>
      import('./platform/ThemeLibraryPage').then((module) => ({
        default: module.ThemeLibraryPage,
      })),
    name: 'Themes',
    permissions: ['analytics:dashboard:read'],
    nav: { icon: { name: 'Palette', size: 20 }, showInNav: true, order: 5 },
  },
  {
    path: '/themes/new',
    component: () =>
      import('./platform/ThemeCreatePage').then((module) => ({ default: module.ThemeCreatePage })),
    name: 'New theme',
    permissions: ['analytics:themes:write'],
    nav: { showInNav: false },
  },
  {
    path: '/themes/:id',
    component: () =>
      import('./platform/ThemeStudioPage').then((module) => ({ default: module.ThemeStudioPage })),
    name: 'Theme studio',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/create',
    component: () =>
      import('./platform/VisualCreatorPage').then((module) => ({
        default: module.VisualCreatorPage,
      })),
    name: 'Create chart',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/executive',
    component: redirect('AnalyticsHomeRedirect'),
    name: 'Analytics redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/orders',
    component: redirect('RevenueFulfillmentRedirect'),
    name: 'Orders analytics redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/inventory',
    component: redirect('InventoryWarehouseRedirect'),
    name: 'Inventory analytics redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/warehouse',
    component: redirect('InventoryWarehouseRedirect'),
    name: 'Warehouse analytics redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/shipments',
    component: redirect('LogisticsDeliveryRedirect'),
    name: 'Shipment analytics redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/lab',
    component: redirect('AnalyticsHomeRedirect'),
    name: 'Analytics lab redirect',
    permissions: ['analytics:dashboard:read'],
    nav: { showInNav: false },
  },
  {
    path: '/sustainability',
    component: () =>
      import('./pages/SustainabilityDashboard').then((m) => ({
        default: m.SustainabilityDashboard,
      })),
    name: 'Sustainability',
    description: 'Company shipment carbon (CO2e) footprint dashboard',
    permissions: ['analytics:dashboard:read'],
    nav: { icon: { name: 'Leaf', size: 20 }, showInNav: true, order: 6 },
  },
]);
